import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "tag", "innerRef"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'a'
};
var CardLink = function CardLink(props) {
  var className = props.className,
    cssModule = props.cssModule,
    Tag = props.tag,
    innerRef = props.innerRef,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = mapToCssModules(classNames(className, 'card-link'), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    ref: innerRef,
    className: classes
  }));
};
CardLink.defaultProps = defaultProps;
export default CardLink;